import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import AuthService from "../../utils/AuthService";
import { saveAs } from "file-saver";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  TextField,
  Checkbox,
  ListItemText,
  Paper,
  Box,
  Button,
  Typography,
  Grid,
  Card,
  Collapse,
  LinearProgress,
  useMediaQuery,
  Divider,
  FormControlLabel,
  CardContent,
  FormControl,
  InputLabel,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import ApiMap from "../../utils/ApiMap";
//import data from "./assignmentconfig.json";
import axios from "axios";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CircularProgress from "@mui/material/CircularProgress";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DownloadIcon from "@mui/icons-material/Download";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const Assignment = () => {
  //const { columns, data: rowData } = data.Content;
  const [userInputs, setUserInputs] = useState({});
  const [facultyInputs, setFacutlyInputs] = useState({});
  const userAssignmentId = useRef();
  //const location = useLocation();
  const [myAssignment, setMyAssignment] = useState();
  const [assignmentId, setAssignmentId] = useState(null);
  const [userAssignment, setUserAssignment] = useState(null);
  const [assignment, setAssignment] = useState(null);
  //const [assignmentInfo, setAssignmentInfo] = useState({});
  const [submissions, setSubmissions] = useState(null);
  const [showSubmissions, setShowSubmissions] = useState(true);
  const [loadingAssignment, setLoadingAssignment] = useState(true);
  const [loadingSubmissions, setLoadingSubmissions] = useState(true);
  //const { courseId, moduleId, chapterId, contentId } = location.state || {};
  const { courseId, moduleId, chapterId, lessonId } = useParams();
  const [selectedStudentIndex, setSelectedStudentIndex] = useState(null);
  const [resubmitChecked, setResubmitChecked] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [columns, setColumns] = useState([]);
  //const [updating, setUpdating] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState("idle");
  const [gradeStatus, setGradeStatus] = useState("");
  const contentId = lessonId;
  const isMobile = useMediaQuery("(max-width:600px)");
  const isInstructor = AuthService.isFaculty(courseId);
  //const [isBlocking, setIsBlocking] = useState(true);
  const [gradedUserIds, setGradedUserIds] = useState([]);
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [selectedComment, setSelectedComment] = useState("");

  const handleOpenCommentDialog = (text) => {
    setSelectedComment(text);
    setOpenCommentDialog(true);
  };
  const handleCloseCommentDialog = () => setOpenCommentDialog(false);

  const getAssignment = async () => {
    if (assignmentId > 0) {
      return;
    }
    const resp = await axios(
      `${ApiMap.MYASSIGNMENT}/myassignment/${courseId}/module/${moduleId}/chapter/${chapterId}/lesson/${contentId}`,
      AuthService.getAuthHeader()
    );
    console.log(resp);
    if (resp.data.UserAssignmentId) {
      //setUserAssignmentId(resp.data.UserAssignmentId);
      userAssignmentId.current = resp.data.UserAssignmentId;
      console.log(resp.data);
      setUserAssignment(resp.data.Assignment);
      var myA = {};
      myA.GradeSubmitDate = resp.data.SubmitDate;
      myA.UserAssignmentId = resp.data.UserAssignmentId;
      myA.Assignment = resp.data.Assignment;
      myA.Score = resp.data.StudentScore;
      myA.MemberId = resp.data.MemberId;
      myA.GradedDate = resp.data.GradedDate;
      myA.TeacherComment = resp.data.TeacherComment;
      myA.StudentComment = resp.data.Studentcomment;
      myA.Resubmit = resp.data.ReSubmit;
      myA.AssignmentScore = resp.data.AssignmentScore;
      setMyAssignment(myA);
    } else {
      setUserAssignment(resp.data.Content);
    }

    if (!assignment) {
      setAssignment(resp.data.Content);
    }
    var ainfo = {};
    ainfo.Title = resp.data.Title;
    ainfo.Name = resp.data.Name;
    ainfo.CourseName = resp.data.CourseName;
    ainfo.ModuleName = resp.data.ModuleName;
    ainfo.Duration = resp.data.DurationMin;
    ainfo.Score = resp.data.AssignmentScore;
    //setAssignmentInfo(ainfo);
    setAssignmentId(resp.data.AssignmentId);
    setLoadingAssignment(false);
  };

  useEffect(() => {
    let source;
    if (
      selectedStudentIndex !== null &&
      submissions?.[selectedStudentIndex]?.Assignment &&
      submissions[selectedStudentIndex].Assignment.data?.length
    ) {
      source = submissions[selectedStudentIndex].Assignment;
    } else if (
      userAssignment?.data?.length &&
      userAssignment?.columns?.length
    ) {
      source = userAssignment;
    } else if (assignment?.data?.length && assignment?.columns?.length) {
      source = assignment;
    }
    if (!source?.data?.length || !source?.columns?.length) return;

    if (!source?.data || !source?.columns) return;
    setColumns(source.columns);
    const transformedData = source.data.map((row, rowIndex) =>
      row.map((cell, colIndex) => {
        const isTeacherCommentRow = source.columns?.[rowIndex]?.name
          ?.toLowerCase()
          .includes("teacher");

        if (isTeacherCommentRow) {
          return {
            type: "text",
            submittedValue: typeof cell === "string" ? cell : "",
            answer: "",
          };
        }

        const originalAssignmentCell = assignment?.data?.[rowIndex]?.[colIndex];

        if (
          typeof originalAssignmentCell === "string" &&
          originalAssignmentCell.trim()
        ) {
          // Treat as a question (only if assignment has string for this cell)
          return {
            type: "question",
            value: originalAssignmentCell,
          };
        }

        // if (Array.isArray(cell)) {
        //   return {
        //     type: "picklist",
        //     picklist: cell.map((option) => ({
        //       value: option?.value || "",
        //       isCorrect: !!option?.isCorrect,
        //       submittedValue: !!option?.submittedValue,
        //     })),
        //   };
        // }

        if (typeof cell === "object" && cell?.type) {
          return cell;
        }

        return {
          type: "text",
          submittedValue:
            typeof cell === "string" || typeof cell === "number" ? cell : "",
          answer: "",
        };
      })
    );

    console.log(transformedData);
    setRowData(transformedData);
    localStorage.removeItem("assignmentUnsaved");
    setUserInputs({});
  }, [assignment, submissions, selectedStudentIndex, userAssignment]);

  useEffect(() => {
    if (selectedStudentIndex === null || !submissions[selectedStudentIndex])
      return;

    const currentSubmission = submissions[selectedStudentIndex];
    setResubmitChecked(!!currentSubmission?.Resubmit);
  }, [selectedStudentIndex, submissions]);

  const getSubmissions = async () => {
    const resp = await axios(
      `${ApiMap.MYASSIGNMENT}/assignmentstograde/${courseId}/module/${moduleId}/chapter/${chapterId}/lesson/${contentId}`,
      AuthService.getAuthHeader()
    );
    setSubmissions(resp.data);
    setLoadingSubmissions(false);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (assignmentId < 1) {
      getAssignment();
    }
  }, [assignmentId]);

  // useEffect(() => {
  //   const handleBeforeUnload = (e) => {
  //     if (isBlocking) {
  //       e.preventDefault();
  //       e.returnValue = ""; // Required for some browsers
  //     }
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  // }, [isBlocking]);

  useEffect(() => {
    if (
      AuthService.isFaculty(courseId) &&
      assignmentId != null &&
      !submissions
    ) {
      console.log("Calling getSubmissions with:", {
        courseId,
        moduleId,
        chapterId,
        contentId,
      });
      getSubmissions();
    }
  });

  useEffect(() => {
    const fetchGradedUserIds = async () => {
      const requestBody = {
        Name: "StudentSubmissions",
        IndexName: "index2",
        Key: "grades",
        SKey: {
          value: `crs#${courseId};mod#${moduleId};chp#${chapterId}`,
          optype: "begins",
        },
      };

      try {
        const response = await axios.post(
          "https://dev.marvelapi.com/app/v1/getitems",
          requestBody,
          AuthService.getAuthHeader()
        );

        const result = response.data;
        console.log(result);

        const gradedUserIds = result
          ?.filter((item) => {
            if (!item?.graded) return false;

            const sk = item.SK;
            const lessonMatch = sk?.match(/id#(\d+)/);
            const skLessonId = lessonMatch?.[1];

            return skLessonId === lessonId;
          })
          .map((item) => item.PK?.split("#")[1]); // extract userId

        setGradedUserIds(gradedUserIds || []);
      } catch (error) {
        console.error("Error fetching graded user IDs:", error);
      }
    };

    fetchGradedUserIds();
  }, [courseId, moduleId, chapterId, lessonId]);

  const getCellBackground = useCallback(
    (rowIndex, colIndex) => {
      const isTeacherColumn = columns?.[colIndex]?.name
        ?.toLowerCase()
        .includes("teacher");
      if (isTeacherColumn) return "inherit"; // no background for teacher columns

      const originalCell = assignment?.data?.[colIndex]?.[rowIndex];
      let submittedCell;
      if (isInstructor) {
        // Instructor is viewing a student's submission
        submittedCell =
          submissions?.[selectedStudentIndex]?.Assignment?.data?.[colIndex]?.[
            rowIndex
          ];
      } else {
        // Student is logged in — check their own submitted data
        submittedCell = userAssignment?.data?.[colIndex]?.[rowIndex];
      }

      if (!originalCell && submittedCell) return "#ffebee"; // student entered only
      if (originalCell && submittedCell && originalCell !== submittedCell)
        return "#fff9c4"; // mismatch
      return "inherit"; // same or no data
    },
    [assignment, submissions, selectedStudentIndex, userInputs, isInstructor]
  );

  // ✅ Tick Mark Logic
  // -----------------------------------------------------------------
  // Resubmit = true  && SubmitDate > GradeDate → 🟠 Orange Tick
  //   → Student has resubmitted AFTER grading, teacher needs to look.
  //
  // Resubmit = true  && SubmitDate < GradeDate → 🔴 Red Tick
  //   → Student has NOT resubmitted since grading,
  //     teacher can remind student to resubmit.
  //
  // Resubmit = false && SubmitDate < GradeDate → 🟢 Green Tick
  //   → Done, graded and no resubmission needed.
  //
  // Resubmit = false && SubmitDate > GradeDate → 🟢 Green Tick (rare)
  //   → Not common case, but keep in mind for future edge-cases.

  // Determine tick color based on resubmit and submit/grade dates
  const getTickColor = (submission) => {
    console.log(!submission.GradedDate);
    if (!submission.GradedDate) return "grey";
    const submitDate = new Date(submission.SubmitDate);
    const gradeDate = new Date(submission.GradedDate);

    if (submission.Resubmit) {
      if (submitDate > gradeDate) return "orange"; // resubmitted after grading
      if (submitDate < gradeDate) return "red"; // needs to resubmit
    } else {
      if (submitDate < gradeDate) return "green"; // done
      if (submitDate > gradeDate) return "green"; // rare case
    }
  };

  const downloadCSV = () => {
    if (!rowData?.length || !columns?.length) return;

    // Prepare CSV header
    const headers = ["Sl. #", ...columns.map((col) => col.name)];

    // ✅ Find the maximum row count among all columns
    const totalRows = Math.max(...rowData.map((col) => col.length));

    const csvRows = [];

    // ✅ Loop row by row (across all columns)
    for (let rowIndex = 0; rowIndex < totalRows; rowIndex++) {
      const row = [rowIndex + 1]; // Sl. #

      for (let colIndex = 0; colIndex < columns.length; colIndex++) {
        const cell = rowData[colIndex]?.[rowIndex];
        let value = "";

        if (typeof cell === "object" && cell !== null) {
          value = cell.submittedValue ?? cell.value ?? "";
        } else if (cell != null) {
          value = cell;
        }

        // escape quotes and commas
        value = String(value).replace(/"/g, '""');
        row.push(`"${value}"`);
      }

      csvRows.push(row.join(","));
    }

    // ✅ Combine header and rows
    const csvContent = [headers.join(","), ...csvRows].join("\n");

    // ✅ Add BOM for UTF-8 (Arabic-safe)
    const bom = "\uFEFF";
    const blob = new Blob([bom + csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    saveAs(blob, `assignment_${assignment?.Name || "data"}.csv`);
  };

  const handleImportCSV = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      let text = e.target.result;

      // ✅ Strip BOM if Excel added it
      if (text.charCodeAt(0) === 0xfeff) text = text.slice(1);

      // ✅ Split lines but DON'T trim or filter(Boolean)
      const lines = text.split(/\r?\n/);
      if (lines.length < 2) {
        alert("CSV seems empty or corrupted!");
        return;
      }

      // ✅ Parse CSV line robustly (handles quotes + empties)
      const parseCSVLine = (line) => {
        const cells = [];
        let current = "";
        let inQuotes = false;

        for (let i = 0; i < line.length; i++) {
          const char = line[i];
          if (char === '"') {
            if (inQuotes && line[i + 1] === '"') {
              current += '"'; // escaped quote
              i++;
            } else {
              inQuotes = !inQuotes;
            }
          } else if (char === "," && !inQuotes) {
            cells.push(current);
            current = "";
          } else {
            current += char;
          }
        }
        cells.push(current);
        return cells.map((c) => c.trim());
      };

      const parsedRows = lines
        .filter((line) => line.trim().length > 0)
        .map(parseCSVLine);

      const headers = parsedRows[0];
      const rows = parsedRows.slice(1);

      // ✅ Validate header match
      const expectedHeaders = ["Sl. #", ...columns.map((c) => c.name)];
      const headersMatch =
        expectedHeaders.length === headers.length &&
        expectedHeaders.every((h, i) => h === headers[i]);

      if (!headersMatch) {
        console.warn("Header mismatch:", headers, expectedHeaders);
        alert("⚠️ CSV headers do not match assignment format!");
        return;
      }

      // ✅ Build column-major structure
      const numCols = columns.length;
      const newRowData = Array.from({ length: numCols }, () => []);

      rows.forEach((row) => {
        for (let colIndex = 0; colIndex < numCols; colIndex++) {
          // +1 skips the "Sl. #" column
          const cell = row[colIndex + 1] ?? "";
          newRowData[colIndex].push({
            type: "text",
            submittedValue: cell,
            answer: "",
          });
        }
      });

      setRowData(newRowData);
      alert("✅ CSV imported successfully!");
    };

    reader.readAsText(file, "utf-8");
    event.target.value = "";
  };

  const handlePicklistChange = (rowIndex, colIndex, selectedValues) => {
    setUserInputs((prev) => ({
      ...prev,
      [`${rowIndex}-${colIndex}`]: selectedValues,
    }));
    rowData[colIndex][rowIndex].submittedValue = selectedValues;

    localStorage.setItem("assignmentUnsaved", "true");
  };

  const handleTextChange = (rowIndex, colIndex, value) => {
    //setIsBlocking(true);
    setUserInputs((prev) => ({
      ...prev,
      [`${rowIndex}-${colIndex}`]: value,
    }));
    localStorage.setItem("assignmentUnsaved", "true");
  };

  const handleSubmitAssignment = async (action) => {
    console.log(userAssignment, assignment, myAssignment);
    setSubmissionStatus(action === "submit" ? "submitting" : "saving");
    let studentId;
    let currentSubmission;

    // Instructor mode
    if (selectedStudentIndex !== null && submissions[selectedStudentIndex]) {
      currentSubmission = submissions[selectedStudentIndex];
      studentId = currentSubmission?.MemberId;
    }
    // Student mode
    else if (userAssignment || assignment) {
      currentSubmission = userAssignment ?? assignment;
      studentId = currentSubmission?.MemberId;
    } else {
      setSubmissionStatus("idle");
      console.error("No student or assignment found");
      return;
    }

    const maxRows = Math.max(...rowData.map((col) => col.length));
    const maxCols = columns.length;

    const formattedData = Array.from({ length: maxCols }, (_, colIndex) =>
      Array.from({ length: maxRows }, (_, rowIndex) => {
        const key = `${rowIndex}-${colIndex}`;
        const userInput = userInputs[key];

        const cell = rowData[colIndex]?.[rowIndex];
        const submitted =
          typeof cell === "object" ? cell.submittedValue : undefined;
        const original = typeof cell === "object" ? cell.value : cell;

        return userInput ?? submitted ?? original ?? "";
      })
    );

    const assignmentObj = {
      Value: {
        lines: 1,
        columns: columns.map((col) => ({
          ...col,
          direction: col.direction || "rtl",
        })),
        data: formattedData,
      },
    };

    if (studentId) {
      assignmentObj["StudentId"] = studentId;
    }

    // If it's a fresh assignment (no userAssignmentId yet) → create first
    if (!userAssignmentId.current) {
      try {
        const createUrl = `${ApiMap.CREATEASSIGNMENT}/userassignment/${courseId}/module/${moduleId}/chapter/${chapterId}/lesson/${contentId}`;
        const createResp = await axios.put(
          createUrl,
          currentSubmission, // send the base assignment object
          AuthService.getAuthHeader()
        );

        if (createResp.status === 200) {
          userAssignmentId.current = createResp.data.id; // store ID for updates
        }
      } catch (err) {
        console.error("Error creating userAssignment", err);
        setSubmissionStatus("idle");
        return;
      }
    }

    // Now attach the Id for update
    assignmentObj["Id"] = parseInt(userAssignmentId.current);

    try {
      const updateUrl = `${ApiMap.UPDT_ASSIGNMENT}/userassignment/${courseId}/module/${moduleId}/chapter/${chapterId}/lesson/${contentId}`;
      const response = await axios.post(
        updateUrl,
        assignmentObj,
        AuthService.getAuthHeader()
      );

      if (response.status === 200) {
        setSubmissionStatus(action === "submit" ? "submitted" : "saved");
      }
    } catch (err) {
      console.error("Error updating assignment", err);
      setSubmissionStatus("idle");
    }

    localStorage.removeItem("assignmentUnsaved");
  };

  // const handleResubmit = (submission) => {
  //   console.log("Resubmit clicked for:", submission.FirstName);
  //   // Implement your resubmit logic here
  // };

  const handleGradeSubmit = (
    submission,
    newStudentScore,
    gradeComment,
    resubmit
  ) => {
    const assignmentObj = {
      comment: gradeComment,
      score: newStudentScore,
      resubmit: resubmit,
      Id: submission.UserAssignmentId,
      studentId: submission.MemberId,
      assignmentGrades: submission.AssignmentScore,
    };
    //setUpdating(true);
    setGradeStatus("submitting");
    var url = `${ApiMap.UPDT_ASSIGNMENT}/gradeassignment/${courseId}/module/${moduleId}/chapter/${chapterId}/lesson/${contentId}`;
    async function update() {
      try {
        const response = await axios.post(
          url,
          assignmentObj,
          AuthService.getAuthHeader()
        );
        //setUpdating(false);
        if (response.status >= 200 && response.status < 300) {
          const updatedSubmissions = [...submissions];
          updatedSubmissions[selectedStudentIndex] = {
            ...submissions[selectedStudentIndex],
            Resubmit: resubmit, // Add this field if not present
          };
          setSubmissions(updatedSubmissions);
          setGradeStatus("submitted");
        }
      } catch (err) {
        console.log(err);
        //setUpdating(false);
        setGradeStatus("error");
      }
    }
    update();
    // Implement your backend call or logic here
  };

  if (loadingAssignment) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        <LinearProgress color="secondary" sx={{ width: "20%" }} />
        <Typography variant="body2" color="textSecondary">
          Loading assignment...
        </Typography>
      </Box>
    );
  }

  if (loadingSubmissions && isInstructor) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        <LinearProgress color="secondary" sx={{ width: "20%" }} />
        <Typography variant="body2" color="textSecondary">
          Loading submissions...
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ direction: "rtl" }}>
      <Box
        sx={{
          direction: "ltr",
          margin: 2,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        {AuthService.isFaculty(courseId) && (
          <Box sx={{ margin: 1 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: 2,
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  marginRight: 2,
                  fontSize: "1rem",
                  fontWeight: 600,
                  lineHeight: "normal",
                  color: "primary.main",
                }}
              >
                Submissions: {submissions?.length}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: 3,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <CheckCircleIcon sx={{ color: "orange", fontSize: 18 }} />
                  <Typography variant="body2">
                    Needs Teacher's Review
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <CheckCircleIcon sx={{ color: "red", fontSize: 18 }} />
                  <Typography variant="body2">Student must resubmit</Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <CheckCircleIcon sx={{ color: "green", fontSize: 18 }} />
                  <Typography variant="body2">Done</Typography>
                </Box>
              </Box>

              <Button
                variant="text"
                onClick={() => setShowSubmissions((prev) => !prev)}
                sx={{
                  minWidth: 20,
                  padding: 1,
                }}
              >
                {showSubmissions ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </Button>
            </Box>
            {showSubmissions && (
              <Collapse in={showSubmissions}>
                {Array.isArray(submissions) && submissions.length > 0 ? (
                  isMobile ? (
                    // Mobile: Display as a List
                    <FormControl fullWidth sx={{ marginBottom: 2 }}>
                      <InputLabel id="mobile-student-select-label">
                        Select Student
                      </InputLabel>
                      <Select
                        labelId="mobile-student-select-label"
                        value={selectedStudentIndex ?? ""}
                        label="Select Student"
                        onChange={(e) => {
                          setSelectedStudentIndex(Number(e.target.value));
                          setGradeStatus("");
                        }}
                        renderValue={(selectedIndex) =>
                          submissions[selectedIndex]?.FirstName || ""
                        }
                      >
                        {submissions.map((submission, index) => {
                          const isGraded = gradedUserIds.includes(
                            submission.MemberId
                          );
                          const isSelected = selectedStudentIndex === index;
                          return (
                            <MenuItem
                              key={index}
                              value={index}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                backgroundColor: isSelected
                                  ? "action.selected"
                                  : "transparent", // ✅ highlight selected
                              }}
                            >
                              <span>{submission.FirstName}</span>
                              {isGraded && !isSelected && (
                                <CheckCircleIcon
                                  sx={{
                                    fontSize: 18,
                                    color: getTickColor(submission),
                                  }}
                                />
                              )}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  ) : (
                    // Desktop: Display as Grid of Cards
                    <Grid container spacing={2}>
                      {submissions.map((submission, index) => {
                        const isGraded = gradedUserIds.includes(
                          submission.MemberId
                        );
                        return (
                          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                            <Card
                              variant="outlined"
                              sx={{
                                padding: 2,
                                position: "relative",
                                backgroundColor:
                                  selectedStudentIndex === index
                                    ? "action.selected"
                                    : "background.paper", // ✅ highlight selected
                                border:
                                  selectedStudentIndex === index
                                    ? "2px solid"
                                    : "1px solid",
                                borderColor:
                                  selectedStudentIndex === index
                                    ? "primary.main"
                                    : "divider",
                              }}
                            >
                              {/* ✅ Positioned Graded Icon in top-right */}
                              {isGraded && (
                                <CheckCircleIcon
                                  sx={{
                                    position: "absolute",
                                    top: 8,
                                    right: 8,
                                    fontSize: 18,
                                    color: getTickColor(submission), // orange/red if resubmitted, grey if none
                                  }}
                                />
                              )}

                              {/* Student Name */}
                              <Typography
                                variant="subtitle1"
                                fontWeight="bold"
                                gutterBottom
                                onClick={() => {
                                  if (selectedStudentIndex !== index) {
                                    setSelectedStudentIndex(index);
                                    setGradeStatus("");
                                  }
                                }}
                                sx={{
                                  textDecoration: "underline",
                                  color: "primary.main",
                                  cursor: "pointer",
                                }}
                              >
                                {submission.FirstName}
                              </Typography>

                              {/* Submit Date */}
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {submission.SubmitDate &&
                                !isNaN(new Date(submission.SubmitDate))
                                  ? new Date(
                                      submission.SubmitDate
                                    ).toLocaleString()
                                  : new Date().toLocaleString()}
                              </Typography>
                            </Card>
                          </Grid>
                        );
                      })}
                    </Grid>
                  )
                ) : null}

                {selectedStudentIndex !== null && (
                  <Box mt={4}>
                    <Divider sx={{ mb: 2 }} />
                    <Typography variant="h6" gutterBottom>
                      <strong>Grading: </strong>
                      {submissions[selectedStudentIndex]?.FirstName}
                    </Typography>

                    <Typography variant="body2" sx={{ mb: 2 }}>
                      <strong>Grade: </strong>
                      {submissions[selectedStudentIndex].StudentScore} /
                      {submissions[selectedStudentIndex].AssignmentScore}
                    </Typography>

                    {/* Editable StudentScore */}
                    <TextField
                      label="Student Score"
                      type="number"
                      inputProps={{
                        min: 0,
                        max: submissions[selectedStudentIndex].AssignmentScore,
                      }}
                      value={
                        facultyInputs[`score-${selectedStudentIndex}`] ??
                        submissions[selectedStudentIndex].StudentScore
                      }
                      onChange={(e) => {
                        const inputValue = Number(e.target.value);
                        const maxScore =
                          submissions[selectedStudentIndex].AssignmentScore;
                        if (inputValue <= maxScore) {
                          setFacutlyInputs((prev) => ({
                            ...prev,
                            [`score-${selectedStudentIndex}`]: inputValue,
                          }));
                        }
                      }}
                      sx={{
                        mb: 2,
                        width: "100%",
                        maxWidth: 200,
                        minWidth: 100,
                      }}
                    />

                    {/* Editable TeacherComment */}
                    <TextField
                      label="Teacher Comment"
                      multiline
                      rows={4}
                      value={
                        facultyInputs[`comment-${selectedStudentIndex}`] !==
                        undefined
                          ? facultyInputs[`comment-${selectedStudentIndex}`]
                          : submissions[selectedStudentIndex].TeacherComment ||
                            ""
                      }
                      onChange={(e) =>
                        setFacutlyInputs((prev) => ({
                          ...prev,
                          [`comment-${selectedStudentIndex}`]: e.target.value,
                        }))
                      }
                      fullWidth
                      sx={{ mb: 2 }}
                    />
                    {/* Buttons */}
                    <Box display="flex" flexDirection="column" gap={2}>
                      {/* Checkbox */}
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={resubmitChecked}
                            onChange={(e) =>
                              setResubmitChecked(e.target.checked)
                            }
                            color="secondary"
                          />
                        }
                        label="Resubmit"
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ alignSelf: "flex-start", gap: 1 }}
                        onClick={() =>
                          handleGradeSubmit(
                            submissions[selectedStudentIndex],
                            facultyInputs[`score-${selectedStudentIndex}`] ??
                              submissions[selectedStudentIndex].StudentScore,
                            facultyInputs[`comment-${selectedStudentIndex}`] ??
                              submissions[selectedStudentIndex].TeacherComment,
                            resubmitChecked
                          )
                        }
                      >
                        Grade
                        {gradeStatus === "submitting" ? (
                          <CircularProgress
                            size={16}
                            sx={{ color: "inherit" }}
                          />
                        ) : gradeStatus === "submitted" ? (
                          <CheckCircleIcon
                            sx={{ color: "white", fontSize: 18 }}
                          />
                        ) : null}
                      </Button>
                    </Box>
                  </Box>
                )}
              </Collapse>
            )}
          </Box>
        )}
        {AuthService.isStudent(courseId) && (
          <Card>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Your Grade
              </Typography>
              <Typography variant="body1" color="primary.main">
                <strong>
                  {myAssignment?.Score} out of {myAssignment?.AssignmentScore}
                </strong>
              </Typography>
              <Typography variant="body1">
                <strong>Submitted:</strong> {console.log(myAssignment)}
                {myAssignment?.GradeSubmitDate ? (
                  new Date(myAssignment.GradeSubmitDate).toLocaleString(
                    "en-US",
                    {
                      dateStyle: "medium",
                      timeStyle: "short",
                    }
                  )
                ) : (
                  <em>Not submitted</em>
                )}
              </Typography>

              <Typography variant="body1">
                <strong>Status:</strong>
                {myAssignment?.Graded ? "Graded" : ""}
              </Typography>
            </CardContent>
          </Card>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: 2,
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        {/* Left side: Download icon for students only */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {!isInstructor && (
            <Button
              variant="contained"
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
              onClick={() => handleSubmitAssignment("submit")}
            >
              Submit
              {submissionStatus === "submitting" ? (
                <CircularProgress size={18} sx={{ color: "inherit" }} />
              ) : submissionStatus === "submitted" ? (
                <CheckCircleIcon sx={{ color: "white", fontSize: 18 }} />
              ) : null}
            </Button>
          )}

          <Button
            variant="contained"
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
            onClick={() => handleSubmitAssignment("save")}
          >
            Save
            {submissionStatus === "saving" ? (
              <CircularProgress size={16} sx={{ color: "inherit" }} />
            ) : submissionStatus === "saved" ? (
              <CheckCircleIcon sx={{ color: "white", fontSize: 18 }} />
            ) : null}
          </Button>
        </Box>
        {!isInstructor && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* Download CSV */}
            <Tooltip title="Download Assignment">
              <IconButton
                color="primary"
                onClick={downloadCSV}
                sx={{ border: "1px solid", borderRadius: 1 }}
              >
                <DownloadIcon />
              </IconButton>
            </Tooltip>

            {/* Import CSV */}
            <Tooltip title="Import Assignment CSV">
              <IconButton
                color="primary"
                component="label"
                sx={{ border: "1px solid", borderRadius: 1 }}
              >
                <UploadFileIcon />
                <input
                  type="file"
                  accept=".csv"
                  hidden
                  onChange={handleImportCSV}
                />
              </IconButton>
            </Tooltip>
          </Box>
        )}

        {/* Right side: Submit and Save buttons */}
      </Box>

      <TableContainer component={Paper} sx={{ padding: 2, border: "none" }}>
        <Table
          sx={{
            border: "1px solid black",
            tableLayout: "auto", // ✅ auto width based on content
            width: "100%",
          }}
        >
          <TableHead sx={{ backgroundColor: "primary.main" }}>
            <TableRow>
              {/* ✅ Serial Number Header */}
              <TableCell
                align="center"
                sx={{
                  width: "5%",
                  fontSize: "1rem",
                  fontWeight: 500,
                  color: "#ffffff",
                  whiteSpace: "nowrap",
                }}
              >
                Sl. #
              </TableCell>

              {columns.map((col, colIndex) => {
                const columnWidth =
                  assignment?.columns?.[colIndex]?.width ??
                  userAssignment?.Content?.columns?.[colIndex]?.width ??
                  null;
                const columnName = col.name?.trim()?.toLowerCase();
                const isTeachersCommentColumn =
                  columnName === "teacher's comment";

                return (
                  <TableCell
                    key={colIndex}
                    align="center"
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 500,
                      color: "#ffffff",
                      whiteSpace: "nowrap",
                    }}
                    style={{
                      width: columnWidth
                        ? `${columnWidth}%` // ✅ use JSON-defined width
                        : isTeachersCommentColumn
                        ? "15%" // ✅ fallback width if not specified
                        : "20%", // ✅ reasonable default for undefined columns
                      minWidth: 120, // ✅ keeps it readable even with small text
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {col.name}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {Array.from({
              length: Math.max(...rowData.map((col) => col.length)),
            }).map((_, rowIndex) => (
              <TableRow key={rowIndex} sx={{ borderBottom: "1px solid black" }}>
                {/* ✅ Serial Number Cell */}
                <TableCell
                  align="center"
                  sx={{
                    border: "1px solid grey",
                    fontWeight: 500,
                    backgroundColor: "#f5f5f5",
                    whiteSpace: "nowrap",
                  }}
                >
                  {rowIndex + 1}
                </TableCell>

                {columns.map((_, colIndex) => {
                  const columnDefinition = columns[colIndex] || {};
                  const columnDirection = columnDefinition.direction || "rtl";
                  const allowMultiline =
                    columnDefinition.multiline != null
                      ? columnDefinition.multiline
                      : columnDefinition.allowMultiline != null
                      ? columnDefinition.allowMultiline
                      : true;
                  const textAlign =
                    columnDirection === "ltr" ? "left" : "right";
                  const baseMinRows = Math.max(
                    assignment?.lines ?? userAssignment?.Content?.lines ?? 1,
                    3
                  );
                  const minRows = allowMultiline ? baseMinRows : 1;
                  const cellData = rowData[colIndex]?.[rowIndex];
                  const numberOfLines =
                    assignment?.lines ?? userAssignment?.Content?.lines ?? 1;

                  const columnName = columns[colIndex]?.name
                    ?.trim()
                    ?.toLowerCase();
                  const isTeachersCommentColumn =
                    columnName === "teacher's comment";

                  // 🔹 QUESTION CELL
                  if (cellData?.type === "question") {
                    return (
                      <TableCell
                        key={colIndex}
                        align="center"
                        sx={{
                          border: "1px solid grey",
                          backgroundColor: getCellBackground(
                            rowIndex,
                            colIndex
                          ),
                          direction: columnDirection,
                          fontSize:
                            columnDirection !== "ltr" ? "1.5rem" : "1.2rem",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          overflowWrap: "anywhere",
                          verticalAlign: "top",
                        }}
                      >
                        {cellData.value}
                      </TableCell>
                    );
                  }

                  // 🔹 TEXT CELL
                  if (cellData?.type === "text") {
                    const value =
                      userInputs[`${rowIndex}-${colIndex}`] ??
                      cellData.submittedValue ??
                      "";

                    // 🧑‍🎓 Student view: Comment column opens dialog
                    if (isTeachersCommentColumn && !isInstructor) {
                      return (
                        <TableCell
                          key={colIndex}
                          align="center"
                          sx={{
                            border: "1px solid grey",
                            backgroundColor: getCellBackground(
                              rowIndex,
                              colIndex
                            ),
                            cursor: value ? "pointer" : "default",
                            color: value ? "primary.main" : "text.disabled",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            overflowWrap: "anywhere",
                          }}
                          style={{
                            width: "10%",
                          }}
                          onClick={() => {
                            if (value && value.trim())
                              handleOpenCommentDialog(value);
                          }}
                        >
                          {value ? "View Comment" : "No Comment"}
                        </TableCell>
                      );
                    }

                    // 🧑‍🏫 Teacher or other text columns
                    return (
                      <TableCell
                        key={colIndex}
                        align="center"
                        sx={{
                          border: "1px solid grey",
                          backgroundColor: getCellBackground(
                            rowIndex,
                            colIndex
                          ),
                          direction: columnDirection,
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          overflowWrap: "anywhere",
                          verticalAlign: "top",
                        }}
                        style={{
                          width: isTeachersCommentColumn ? "10%" : "auto",
                        }}
                      >
                        <textarea
                          ref={(el) => {
                            // ✅ Auto-adjust height when data first loads
                            if (el) {
                              el.style.height = "auto";
                              el.style.height = `${el.scrollHeight}px`;
                            }
                          }}
                          style={{
                            width: "100%",
                            height: "auto", // allows auto height
                            minHeight: 24,
                            maxWidth: "100%", // ✅ prevent horizontal overflow
                            fontFamily:
                              'Roboto, "Helvetica", "Arial", sans-serif',
                            resize: "none", // disable manual resize handles
                            overflow: "hidden", // ✅ no scrollbars at all
                            fontSize:
                              columnDirection !== "ltr" ? "1.5rem" : "1rem",
                            padding: "0.5rem 0",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            overflowWrap: "anywhere",
                            border: "none",
                            outline: "none",
                            background: "transparent",
                            lineHeight: 1.5,
                            boxSizing: "border-box",
                          }}
                          value={value}
                          onChange={(e) => {
                            // ✅ Dynamically grow/shrink as user types
                            e.target.style.height = "auto";
                            e.target.style.height = `${e.target.scrollHeight}px`;

                            handleTextChange(
                              rowIndex,
                              colIndex,
                              e.target.value
                            );
                          }}
                          onFocus={(e) => {
                            // ✅ Ensure expansion on focus (in case text loads truncated)
                            e.target.style.height = "auto";
                            e.target.style.height = `${e.target.scrollHeight}px`;
                          }}
                          disabled={isTeachersCommentColumn && !isInstructor}
                        />
                      </TableCell>
                    );
                  }

                  // 🔹 PICKLIST CELL
                  if (cellData?.type === "picklist") {
                    return (
                      <TableCell
                        key={colIndex}
                        align="center"
                        sx={{
                          border: "1px solid grey",
                          backgroundColor: getCellBackground(
                            rowIndex,
                            colIndex
                          ),
                          direction: columnDirection,
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          overflowWrap: "anywhere",
                        }}
                        style={{
                          width: "auto",
                        }}
                      >
                        <Select
                          multiple
                          value={userInputs[`${rowIndex}-${colIndex}`] || []}
                          onChange={(e) =>
                            handlePicklistChange(
                              rowIndex,
                              colIndex,
                              e.target.value
                            )
                          }
                          renderValue={(selected) => selected.join(", ")}
                          sx={{ width: "100%" }}
                        >
                          {cellData.picklist.map((option, idx) => (
                            <MenuItem key={idx} value={option.value}>
                              <Checkbox
                                checked={userInputs[
                                  `${rowIndex}-${colIndex}`
                                ]?.includes(option.value)}
                              />
                              <ListItemText primary={option.value} />
                            </MenuItem>
                          ))}
                        </Select>
                      </TableCell>
                    );
                  }

                  // 🔹 DEFAULT CELL
                  return (
                    <TableCell
                      key={colIndex}
                      sx={{
                        border: "1px solid grey",
                        fontSize: "1.2rem",
                        backgroundColor: getCellBackground(rowIndex, colIndex),
                        direction: columnDirection,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "anywhere",
                        verticalAlign: "top",
                      }}
                      style={{
                        width: isTeachersCommentColumn ? "10%" : "auto",
                      }}
                    >
                      <TextField
                        fullWidth
                        variant="standard"
                        value={
                          userInputs[`${rowIndex}-${colIndex}`] ??
                          (typeof cellData === "object"
                            ? cellData.submittedValue ?? cellData.value
                            : cellData) ??
                          ""
                        }
                        multiline={numberOfLines > 1}
                        minRows={numberOfLines > 1 ? numberOfLines : 1}
                        onChange={(e) =>
                          handleTextChange(rowIndex, colIndex, e.target.value)
                        }
                        disabled={isTeachersCommentColumn && !isInstructor}
                        InputProps={{
                          disableUnderline: true,
                          sx: {
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            overflowWrap: "anywhere",
                          },
                        }}
                      />
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog
        open={openCommentDialog}
        onClose={handleCloseCommentDialog}
        fullWidth
      >
        <DialogTitle>Teacher’s Comment</DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              lineHeight: 1.6,
            }}
          >
            {selectedComment || "No comment available"}
          </Typography>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Assignment;
